import type { MessageKey } from "./ru"

export const bnMessages = {
  "common.loading": "লোড হচ্ছে...",
  "common.error": "ত্রুটি",
  "common.back": "পেছনে",
  "common.next": "পরবর্তী",
  "common.search": "খুঁজুন",
  "auth.loginErrorTitle": "সাইন-ইন ত্রুটি",
  "auth.openViaTelegram": "Telegram-এর মাধ্যমে অ্যাপটি খুলুন",
  "auth.telegramRequired": "অ্যাপটি Telegram-এর মাধ্যমে খুলতে হবে",
  "auth.authorizationError": "অনুমোদন ত্রুটি",
  "device.rotatePortrait": "ডিভাইসটি পোর্ট্রেট মোডে ঘোরান",
  "country.brazil": "ব্রাজিল",
  "country.vietnam": "ভিয়েতনাম",
  "country.egypt": "মিশর",
  "country.india": "ভারত",
  "country.indonesia": "ইন্দোনেশিয়া",
  "country.iran": "ইরান",
  "country.spain": "স্পেন",
  "country.italy": "ইতালি",
  "country.kazakhstan": "কাজাখস্তান",
  "country.colombia": "কলম্বিয়া",
  "country.malaysia": "মালয়েশিয়া",
  "country.mexico": "মেক্সিকো",
  "country.nigeria": "নাইজেরিয়া",
  "country.pakistan": "পাকিস্তান",
  "country.russia": "রাশিয়া",
  "country.usa": "যুক্তরাষ্ট্র",
  "country.turkey": "তুরস্ক",
  "country.uzbekistan": "উজবেকিস্তান",
  "country.ukraine": "ইউক্রেন",
  "country.philippines": "ফিলিপাইন",
  "countrySelection.chooseCountry": "দেশ নির্বাচন করুন",
  "countrySelection.openAria": "দেশ নির্বাচন করুন",
  "languageSelection.chooseLanguage": "ভাষা নির্বাচন করুন",
  "commercial.direction.autotrade": "গাড়ির বাজার",
  "commercial.direction.insurance": "বীমা",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "রাস্তায় সহায়তা",
  "commercial.searchLabel": "BeepApp অনুসন্ধান",
  "commercial.cityPlaceholder": "শহর লিখুন",
  "commercial.emptyTitle": "আজ কোনো অফার নেই",
  "commercial.emptyLine1": "আপনার শহরে এখনো কোনো সক্রিয় BeepApp অংশীদার নেই",
  "commercial.emptyLine2": "আমরা ইতিমধ্যে তাদের খুঁজে সংযুক্ত করার কাজ করছি",
  "commercial.emptyLine3": "নতুন অফার এখানে স্বয়ংক্রিয়ভাবে দেখা যাবে",
  "commercial.helperLine1": "উপলভ্য অফার দেখতে",
  "commercial.helperLine2": "আপনার শহর লিখুন",
  "commercial.partnerPrompt": "BeepApp অংশীদার হতে চান?",
  "commercial.apply": "আবেদন করুন",
  "main.admin": "অ্যাডমিন",
  "main.garage": "গ্যারেজ",
  "main.signalSent": "সংকেত পাঠানো হয়েছে",
  "main.partnerInviteUnavailable": "অংশীদার আমন্ত্রণ উপলভ্য নয়",
  "main.enterPlate": "গাড়ির নম্বর লিখুন",
  "main.searchError": "অনুসন্ধান ত্রুটি",
  "main.signalSendError": "সংকেত পাঠানো যায়নি",
  "main.shareCardPrefix": "নম্বর কার্ড",
  "main.shareLinkError": "লিংক প্রস্তুত করা যায়নি",
  "main.searchByPlateAria": "নম্বর দিয়ে খুঁজুন",
  "main.russianPlateAria": "রাশিয়ান গাড়ির নম্বর",
  "main.plateAria": "গাড়ির নম্বর",
  "main.findPlateAria": "নম্বর খুঁজুন",
  "main.loadingVehicle": "নম্বর কার্ড লোড হচ্ছে…",
  "main.leaveSignal": "সংকেত পাঠান",
  "main.share": "শেয়ার করুন",
  "signalSelection.chooseType": "সংকেতের ধরন নির্বাচন করুন",
  "signalSelection.category.attention": "ব্যক্তিগত",
  "signalSelection.category.road": "সড়ক",
  "signalSelection.category.urgent": "জরুরি",
  "signalSelection.chooseSignal": "সংকেত নির্বাচন করুন",
  "signalSelection.suggestOwn": "নিজের প্রস্তাব দিন",
  "signalConfirmation.title": "সংকেত নিশ্চিত করুন",
  "signalConfirmation.plateHeading": "গাড়ির নম্বর যাচাই করুন",
  "signalConfirmation.signalHeading": "নির্বাচিত সংকেত যাচাই করুন",
  "signalConfirmation.replyTitle": "Telegram-এ উত্তর দেওয়ার অনুমতি দিন",
  "signalConfirmation.replyBody": "এটি চালু করলে নম্বরের মালিক আপনাকে\nTelegram-এ লিখতে পারবেন। উত্তর দেওয়া সম্ভব হবে কেবল\nআপনার @username থাকলে। উত্তর দেওয়ার সিদ্ধান্ত\nনম্বরের মালিকের।",
  "signalConfirmation.consentText": "আমি নিশ্চিত করছি যে এই সংকেতটি\nবাস্তব পরিস্থিতির ভিত্তিতে এবং এটি স্প্যাম\nবা মিথ্যা প্রতিবেদন নয়।",
  "signalConfirmation.warning": "পাঠানোর পর সংকেতটি\nপরিবর্তন করা যাবে না",
  "signalConfirmation.sending": "পাঠানো হচ্ছে…",
  "signalConfirmation.send": "পাঠান",
  "partner.loadingAria": "লোড হচ্ছে",
  "partner.title": "অংশীদার কর্মসূচি",
  "partner.offerLine1": "আপনার আমন্ত্রণে BeepApp-এ আসা ব্যবহারকারীদের সব পেমেন্ট থেকে",
  "partner.offerLine2": "সময়সীমাহীন ৩০% আয় করুন",
  "partner.offerLine3": "Telegram Affiliate-এর মাধ্যমে",
  "partner.connectUnavailable": "Telegram Affiliate প্রোগ্রাম কনফিগার করার পর সংযোগ উপলভ্য হবে।",
  "partner.connectTelegram": "Telegram-এ সংযুক্ত করুন",
  "partner.qrAria": "অংশীদার লিংকের QR কোড",
  "partner.download": "ডাউনলোড",
  "partner.promoHeading": "ব্যক্তিগত promo code তৈরি করুন",
  "partner.promoHelperLine1": "Promo code অতিরিক্ত এক বছরের সাবস্ক্রিপশন সক্রিয় করে",
  "partner.promoHelperLine2": "এবং ব্যবহারকারী আনতে সাহায্য করে",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "আপনার অংশীদার লিংক",
  "partner.affiliateHelper": "ব্যক্তিগত QR কোড তৈরির জন্য লিংকটি সংরক্ষণ করুন",
  "partner.affiliateAria": "অংশীদার লিংক",
  "partner.qrNoteLine1": "QR কোড আপনার গাড়িতে,",
  "partner.qrNoteLine2": "সামাজিক মাধ্যমে এবং বিজ্ঞাপনী উপকরণে ব্যবহার করা যায়",
  "partner.save": "সংরক্ষণ",
  "partner.reset": "রিসেট",
  "partner.resetConfirm": "সংরক্ষিত অংশীদার লিংক রিসেট করবেন? Promo code আপনারই থাকবে।",
  "partner.promoFormatError": "Promo code ৪ থেকে ১৫ অক্ষরের হতে হবে।",
  "partner.affiliateHostError": "শুধু t.me বা telegram.me লিংক অনুমোদিত।",
  "partner.affiliatePathError": "লিংকে Telegram পাথ নেই।",
  "partner.affiliateFormatError": "অবৈধ অংশীদার লিংক।",
  "partner.loadError": "লোড ত্রুটি",
  "partner.checkInputError": "প্রবেশ করানো তথ্য যাচাই করুন",
  "garageActivation.promoInvalid": "Promo code অবৈধ",
  "garageActivation.plateOccupied": "এই গাড়ির নম্বরটি ইতিমধ্যে সংযুক্ত",
  "garageActivation.activateError": "Garage সক্রিয় করা যায়নি",
  "garageEntry.loadJournalError": "লগবুক লোড করা যায়নি",
  "garageEntry.loadStatusesError": "স্ট্যাটাস লোড করা যায়নি",
  "garageEntry.activationSuccess": "Garage সফলভাবে সক্রিয় হয়েছে",
  "garageEntry.plateAttached": "নম্বর সংযুক্ত হয়েছে",
  "garageEntry.attachError": "নম্বর সংযুক্ত করা যায়নি",
  "garageEntry.activationNote": "আপনার Garage সক্রিয় করুন",
  "garageSheet.activationTitle": "Garage সক্রিয়করণ",
  "garageSheet.plateHelper": "গাড়ির নম্বর লিখুন",
  "garageSheet.promoHelper": "আপনার কি promo code আছে?",
  "garageSheet.cleanBonusLine1": "সক্রিয় করার পর ১ ঘণ্টা",
  "garageSheet.cleanBonusLine2": "বিনামূল্যে “Clean Start” পাবেন",
  "garageSheet.activationFor": "সক্রিয়করণের মেয়াদ",
  "garageSheet.cost": "মূল্য",
  "garageSheet.ownerConsentLine1": "আমি নিশ্চিত করছি যে উল্লেখিত",
  "garageSheet.ownerConsentLine2": "গাড়ির নম্বরযুক্ত গাড়িটির",
  "garageSheet.ownerConsentLine3": "মালিক আমি।",
  "garageSheet.processing": "প্রক্রিয়াধীন...",
  "garageSheet.attach": "সংযুক্ত করুন",
  "garageSheet.pay": "পেমেন্ট করুন",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage নিষ্ক্রিয়করণ",
  "garageLifecycle.cleanWarningLine1": "নম্বরের ইতিহাস মুছে যাবে",
  "garageLifecycle.cleanWarningLine2": "এবং তা পুনরুদ্ধার করা যাবে না!",
  "garageLifecycle.deactivateWarningLine1": "নিষ্ক্রিয় করার পর সক্রিয়",
  "garageLifecycle.deactivateWarningLine2": "Garage ফিচারগুলোর অ্যাক্সেস শেষ হবে",
  "garageLifecycle.willBeDeleted": "মুছে যাবে",
  "garageLifecycle.cleanRemovedLine1": "• লগবুকের সব এন্ট্রি",
  "garageLifecycle.cleanRemovedLine2": "• প্রাপ্ত সংকেতের ইতিহাস",
  "garageLifecycle.cleanRemovedLine3": "• নম্বর কার্ডের প্রকাশ্য",
  "garageLifecycle.cleanRemovedLine4": "  সংকেত কাউন্টার",
  "garageLifecycle.willRemain": "থাকবে",
  "garageLifecycle.cleanPreservedLine1": "• Garage-এর সঙ্গে নম্বরের সংযোগ",
  "garageLifecycle.cleanPreservedLine2": "• বাকি সক্রিয় সময়",
  "garageLifecycle.cleanPreservedLine3": "• নির্বাচিত নম্বর স্ট্যাটাস",
  "garageLifecycle.cleanPreservedLine4": "• নম্বর কার্ডের মোট ভিউ",
  "garageLifecycle.freeFirstHour": "প্রথম ঘণ্টায় বিনামূল্যে",
  "garageLifecycle.willBecomeUnavailable": "অনুপলভ্য হবে",
  "garageLifecycle.deactivateRemovedLine1": "• লগবুক",
  "garageLifecycle.deactivateRemovedLine2": "• নম্বর স্ট্যাটাস নির্বাচন ও ব্যবহার",
  "garageLifecycle.deactivateRemovedLine3": "• আপনি স্বয়ংক্রিয়ভাবে AutoClan ছেড়ে যাবেন",
  "garageLifecycle.deactivateRemovedLine4": "• গাড়ির বাজার",
  "garageLifecycle.deactivateRemovedLine5": "• বীমা",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• রাস্তায় সহায়তা",
  "garageLifecycle.deactivateRemovedLine8": "• গাড়ির নম্বর Garage থেকে বিচ্ছিন্ন হবে",
  "garageLifecycle.willRemainAvailable": "উপলভ্য থাকবে",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• নম্বর অনুসন্ধান এবং",
  "garageLifecycle.deactivatePreservedLine4": "  প্রকাশ্য গাড়ির কার্ড দেখা",
  "garageLifecycle.deactivatePreservedLine5": "• যেকোনো সময় Garage",
  "garageLifecycle.deactivatePreservedLine6": "  আবার সক্রিয় করার সুযোগ",
  "garageLifecycle.cleanConsentLine1": "আমি এই নম্বরের সম্পূর্ণ ইতিহাস",
  "garageLifecycle.cleanConsentLine2": "পুনরুদ্ধারের সুযোগ ছাড়াই মুছে ফেলতে",
  "garageLifecycle.cleanConsentLine3": "সম্মতি দিচ্ছি।",
  "garageLifecycle.deactivateConsentLine1": "আমি নিষ্ক্রিয়করণ এবং সব সক্রিয়",
  "garageLifecycle.deactivateConsentLine2": "Garage ফিচারের অ্যাক্সেস বন্ধ করার",
  "garageLifecycle.deactivateConsentLine3": "বিষয়টি নিশ্চিত করছি।",
  "garageLifecycle.clean": "মুছুন",
  "garageLifecycle.deactivate": "নিষ্ক্রিয় করুন",
} satisfies Record<MessageKey, string>
